import { decodeHexResponse } from '../_common/common.utils';
import {
	NEWSPAPER_APPROVAL_START,
	NEWSPAPER_APPROVAL_SUCCESS,
	NEWSPAPER_APPROVAL_FAILURE,
	APPROVE_NEWSPAPER_START,
	APPROVE_NEWSPAPER_SUCCESS,
	APPROVE_NEWSPAPER_FAILURE,
	REJECT_NEWSPAPER_START,
	REJECT_NEWSPAPER_SUCCESS,
	REJECT_NEWSPAPER_FAILURE,
	DELETE_NEWSPAPER_START,
	DELETE_NEWSPAPER_SUCCESS,
	DELETE_NEWSPAPER_FAILURE,
	BULK_APPROVE_NEWSPAPER_START,
	BULK_APPROVE_NEWSPAPER_SUCCESS,
	BULK_APPROVE_NEWSPAPER_FAILURE,
	NewspaperState,
	NewspaperAction,
	CLEAR_NEWSPAPER_STATUS,
} from './NewspaperApproval.types';

const initialState: NewspaperState = {
	newspaperApprovalResponse: null,
	approveNewspaperResponse: null,
	rejectNewspaperResponse: null,
	deleteNewspaperResponse: null,
	bulkApproveNewspaperResponse: null,
	loading: false,
	error: null,
};

const newspaperApprovalReducer = (
	state = initialState,
	action: NewspaperAction,
): NewspaperState => {
	switch (action.type) {
		// Get Newspaper Allowances
		case NEWSPAPER_APPROVAL_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case NEWSPAPER_APPROVAL_SUCCESS:
			return {
				...state,
				newspaperApprovalResponse:decodeHexResponse(action.payload,"fetchNewspaperApprovalKey"),
				loading: false,
				error: null,
			};
		case NEWSPAPER_APPROVAL_FAILURE:
			return {
				...state,
				newspaperApprovalResponse:decodeHexResponse(action.payload,"fetchNewspaperApprovalKey"),
				loading: false,
				error: action.payload,
			};

		// Approve Newspaper Allowance
		case APPROVE_NEWSPAPER_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case APPROVE_NEWSPAPER_SUCCESS:
			return {
				...state,
				approveNewspaperResponse: decodeHexResponse(action.payload,"approveNewspaperKey"),
				loading: false,
				error: null,
			};
		case APPROVE_NEWSPAPER_FAILURE:
			return {
				...state,
				approveNewspaperResponse: decodeHexResponse(action.payload,"approveNewspaperKey"),
				loading: false,
				error: action.payload,
			};

		// Reject Newspaper Allowance
		case REJECT_NEWSPAPER_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case REJECT_NEWSPAPER_SUCCESS:
			return {
				...state,
				rejectNewspaperResponse: decodeHexResponse(action.payload,"rejectNewspaperKey"),
				loading: false,
				error: null,
			};
		case REJECT_NEWSPAPER_FAILURE:
			return {
				...state,
				rejectNewspaperResponse: decodeHexResponse(action.payload,"rejectNewspaperKey"),
				loading: false,
				error: action.payload,
			};

		// Delete Newspaper Allowance
		case DELETE_NEWSPAPER_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case DELETE_NEWSPAPER_SUCCESS:
			return {
				...state,
				deleteNewspaperResponse: decodeHexResponse(action.payload,"deleteNewspaperKey"),
				loading: false,
				error: null,
			};
		case DELETE_NEWSPAPER_FAILURE:
			return {
				...state,
				deleteNewspaperResponse: decodeHexResponse(action.payload,"deleteNewspaperKey"),
				loading: false,
				error: action.payload,
			};

		// Bulk Approve Newspaper Allowances
		case BULK_APPROVE_NEWSPAPER_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case BULK_APPROVE_NEWSPAPER_SUCCESS:
			return {
				...state,
				bulkApproveNewspaperResponse: decodeHexResponse(action.payload,"bulkApproveNewspaperKey"),
				loading: false,
				error: null,
			};
		case BULK_APPROVE_NEWSPAPER_FAILURE:
			return {
				...state,
				bulkApproveNewspaperResponse: decodeHexResponse(action.payload,"bulkApproveNewspaperKey"),
				loading: false,
				error: action.payload,
			};

		// Clear transient status/messages
		case CLEAR_NEWSPAPER_STATUS:
			return {
				...state,
				approveNewspaperResponse: null,
				rejectNewspaperResponse: null,
				deleteNewspaperResponse: null,
				bulkApproveNewspaperResponse: null,
				error: null,
				loading: false,
			};

		default:
			return state;
	}
};

export default newspaperApprovalReducer;
